<input
  type="text"
  [ngClass]="{'text-right' : !isLeftAligned}"
  [value]="formatValue(value)"
  (input)="onInput($event)"
  maxlength="19"
  [placeholder]="placeholder === undefined ? '' : placeholder"
  pattern="^[0-9]+$"
/>
